export default "__VITE_ASSET__$kzFkUqm__"